import React, { lazy, Suspense } from 'react';
import { Route, Switch, Router } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';

// project imports
import { history } from '../history';
import { HomeRedirect } from '../app/RequireRole';
import { ScreenLoading } from '../app/fallbacks';

// Sign-in pages (outside the app shell)
const Login = lazy(() => import('../views/pages/authentication/Login'));
const Logout = lazy(() => import('../views/pages/authentication/Logout'));
const AuthLogin3 = lazy(() => import('../views/pages/authentication/authentication3/Login3'));
const AuthRegister3 = lazy(() => import('../views/pages/authentication/authentication3/Register3'));

//-----------------------|| ROUTING RENDER ||-----------------------//

// "/" goes to the signed-in role's home page, /pages/* are the sign-in pages,
// and everything else renders inside the app shell (MainRoutes).
const Routes = () => {
    return (
        <Router history={history}>
            <Suspense fallback={<ScreenLoading />}>
                <Switch>
                    <Route exact path="/" component={HomeRedirect} />
                    <Route path="/pages/login/login3" component={AuthLogin3} />
                    <Route path="/pages/register/register3" component={AuthRegister3} />
                    <Route path="/pages/login" component={Login} />
                    <Route path="/pages/logout" component={Logout} />
                    <Route component={MainRoutes} />
                </Switch>
            </Suspense>
        </Router>
    );
};

export default Routes;
